package pl.mothdigital.neuronowi.components.sections.cta

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.forms.*
import com.varabyte.kobweb.silk.components.text.*
import com.varabyte.kobweb.silk.style.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.varabyte.kobweb.silk.components.navigation.*
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.navigation.*
import pl.mothdigital.neuronowi.theme.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import pl.mothdigital.neuronowi.theme.text.*
import com.varabyte.kobweb.compose.css.AlignItems as CssAlignItems
import pl.mothdigital.neuronowi.common.resources.StringResources

@Composable
fun CTASection(
    ctx: PageContext,
    customAction: (() -> Unit)? = null,
) {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .backgroundColor(SiteTheme.green._100)
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .toAttrs()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .alignItems(CssAlignItems.Center)
                .textAlign(TextAlign.Center),
            verticalArrangement = Arrangement.spacedBy(1.cssRem)
        ) {
            AppH2(color = SiteTheme.green._900) {
                Text(StringResources.CTA_SECTION_TITLE.fixPolishOrphans())
            }

            AppP(color = SiteTheme.green._800) {
                Text(StringResources.CTA_SECTION_SUBTITLE.fixPolishOrphans())
            }

            if (customAction != null) {
                Button(
                    onClick = { customAction.invoke() },
                    modifier = Modifier.padding(8.px),
                    type = ButtonType.Button,
                    colorPalette = SiteTheme.green,
                ) {
                    ButtonText()
                }
            } else {
                Link(
                    path = Screen.Contact.route,
                    variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
                    modifier = Modifier.textDecorationLine(TextDecorationLine.None)
                ) {
                    Button(
                        onClick = {},
                        modifier = Modifier.padding(8.px),
                        type = ButtonType.Button,
                        colorPalette = SiteTheme.green,
                    ) {
                        ButtonText()
                    }
                }
            }
        }
    }
}

@Composable
private fun ButtonText() {
    SpanText(
        text = StringResources.CTA_SECTION_BUTTON_TEXT,
        modifier = TextBaseStyle.toModifier().color(SiteTheme.white._900).fontWeight(FontWeight.Normal)
    )
}
